import React from 'react'
import { Link } from 'react-router-dom'

import Logo from '../Logo'
import Phone from '../Phone'
import { Grid, Col } from '../../components/Grid'

import './index.css'
import BEMHelper from 'react-bem-helper'
const classes = new BEMHelper('footer')

export default function Footer () {
  return (
    <footer {...classes('')}>
      <hr />

      <Grid>
        <Col multiple>
          <div><Logo {...classes('logo')} /></div>
          <a href="tel:+4748261953" {...classes('link', 'phone')}><Phone>+4748261953</Phone></a>
          <br />
          <a href="mail:post@appresso.no" {...classes('link', 'email')}>post@appresso.no</a>
          <br />
          <br />
        </Col>
        <Col multiple />
        <Col multiple>
          <nav {...classes('links')}>
            <Link to="/tjenester" {...classes('link')}>Tjenester</Link>
            <Link to="/arbeid" {...classes('link')}>Referanser</Link>
            <Link to="/folka" {...classes('link')}>Folka</Link>
            <Link to="/kontakt" {...classes('link')}>Kontakt</Link>
            {/*<Link to="/rammeverk" {...classes('link')}>Våre rammeverk</Link>*/}
            {/*<Link to="/ting-vi-er-opptatt-av" {...classes('link')}>Prinsipper</Link>*/}
          </nav>
        </Col>
        <Col multiple>
          <nav {...classes('links')}>
            <a href="https://www.facebook.com/appressoas/" {...classes('link')}>Facebook</a>
            <a href="https://www.linkedin.com/company/27096289/" {...classes('link')}>Linkedin</a>
            {/* <a href="https://medium.com" {...classes('link')}>Medium</a> */}
          </nav>
        </Col>
      </Grid>
    </footer>
  )
}



// WEBPACK FOOTER //
// ./src/components/Footer/index.js